import React, { useState } from 'react';
import { Container, Box, Button, Card, CardContent, Grid, TextField, MenuItem, Typography, Chip, CircularProgress } from '@mui/material';
import { Download } from '@mui/icons-material';
import ModuleHeader from '../components/ModuleHeader';
import api from '../axios';
import { errorMsg } from '../utils/errorMsg';

const MODULOS = [
  { v: 'consolidacao', l: 'Consolidação' },
  { v: 'secretaria', l: 'Secretaria' },
  { v: 'startfy', l: 'Start' },
  { v: 'cursos', l: 'Cursos' },
  { v: 'discipulado', l: 'Discipulado' },
  { v: 'grupos_discipulado', l: 'Grupos de Discipulado' },
  { v: 'grupos_crescimento', l: 'Grupos de Crescimento' },
  { v: 'jornada', l: 'Jornada' },
  { v: 'mao_coracao', l: 'Mão e Coração' },
  { v: 'beneficiarios', l: 'Beneficiários (Mão Amiga)' },
];

export default function RelatoriosModulo() {
  const [modulo, setModulo] = useState('consolidacao');
  const [resultado, setResultado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const gerar = async () => {
    setLoading(true); setErro('');
    try { const r = await api.get('/relatorios/resumo', { params: { modulo } }); setResultado(r.data); }
    catch (e) { setErro(errorMsg(e) || 'Erro'); }
    setLoading(false);
  };
  const pdf = async () => {
    try { const r = await api.get('/relatorios/resumo/pdf', { params: { modulo }, responseType: 'blob' }); const url = URL.createObjectURL(new Blob([r.data])); const a = document.createElement('a'); a.href = url; a.download = `relatorio-${modulo}.pdf`; a.click(); URL.revokeObjectURL(url); }
    catch (e) { setErro(errorMsg(e)); }
  };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <ModuleHeader module="Sistema" title="Relatórios" />
      {erro && <Box sx={{ color: 'error.main', mb: 2 }}>{erro}</Box>}
      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <TextField select label="Módulo" value={modulo} onChange={e => setModulo(e.target.value)} sx={{ minWidth: 260 }}>
          {MODULOS.map(m => <MenuItem key={m.v} value={m.v}>{m.l}</MenuItem>)}
        </TextField>
        <Button variant="contained" onClick={gerar} disabled={loading}>Gerar</Button>
        <Button variant="outlined" startIcon={<Download />} onClick={pdf} disabled={!resultado}>Exportar PDF</Button>
      </Box>

      {loading ? <CircularProgress /> : resultado && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Card><CardContent><Typography variant="caption" color="text.secondary">Total</Typography><Typography sx={{ fontWeight: 800, fontSize: '4.4rem', lineHeight: 1 }}>{resultado.total}</Typography></CardContent></Card>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Card><CardContent>
              <Typography variant="caption" color="text.secondary">Por status</Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
                {Object.entries(resultado.por_status || {}).map(([k, v]) => <Chip key={k} label={`${k}: ${v}`} />)}
              </Box>
            </CardContent></Card>
          </Grid>
        </Grid>
      )}
    </Container>
  );
}
